export enum SettingsTabs {
    Profile = 'profile',
    Security = 'security',
    Licensing = 'licensing',
    Notifications = 'notifications',
}

export enum DashboardTabs {
    Security = 'security',
    System = 'system',
    Usage = 'usage',
}

export enum ResourcesTabs {
    Docs = 'docs',
    Cve = 'cve',
}